<template>
<m-pageframe
    title="Edit Incident"
>
<v-container
    v-if="incident != null"
>

    <v-text-field
        label="Incident Id"
        :value="incident.incident_id"
        disabled
        autocomplete="off"
    />

    <m-edit-instant
        label="Creation Time"
        v-model="incident.creation_time"
        v-on:input="doPut"
    />

    <v-select
        label="State"
        :items="states"
        v-model="incident.state"
        v-on:change="doPut"
    />

    <m-edit-instant
        label="Resolution Time"
        v-model="incident.resolution_time"
        v-on:input="doPut"
        v-if="incident.state == 'resolved'"
    />

    Page(s) to show banner:

    <v-checkbox
        label="Home Page"
        v-model="incident.show_banner_home_page"
        v-on:change="doPut"
        style="margin-bottom:-25px;"
    />

    <v-checkbox
        label="Bulk Message Page(s)"
        v-model="incident.show_banner_bulk_message"
        v-on:change="doPut"
    />

    <v-text-field
        label="Home Page Banner Text: Open"
        v-model="incident.open_text_home_page"
        v-on:input="put"
        autocomplete="off"
    />

    <v-text-field
        label="Home Page Banner Text: Resolved"
        v-model="incident.resolved_text_home_page"
        v-on:input="put"
        autocomplete="off"
    />

    <v-text-field
        label="Bulk Message Banner Text: Open"
        v-model="incident.open_text_bulk_message"
        v-on:input="put"
        autocomplete="off"
    />

    <v-text-field
        label="Bulk Message Banner Text: Resolved"
        v-model="incident.resolved_text_bulk_message"
        v-on:input="put"
        autocomplete="off"
    />

    <v-tabs
        v-model="tab"
        style="margin-bottom: 15px;"
    >
        <v-tab>Edit Details</v-tab>
        <v-tab>Preview Details</v-tab>
    </v-tabs>

    <div
         v-show="tab == 0"
    >
        <v-textarea
            label="Details (markdown)"
            v-model="incident.details_markdown"
            v-on:input="put"
            auto-grow
        />

        <p>
            <a href="http://demo.showdownjs.com/" target="_blank">Show Down Demo</a>
        </p>
    </div>

    <m-showdown
        v-show="tab == 1"
        :value="incident.details_markdown"
    />

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            incident: null,
            tab: 0,

            states: ['pending','open','resolved'],
        }
    },

    mounted () {
        this.$rc.showSpinner();
        
        this.$rc.rest(
            'GET: /incidents/:incident_id',
        
            {
                'incident_id' : this.$route.params.incident_id
            },
        
            (data) => {
                this.$rc.hideSpinner();

                this.incident = data;
            },
        
            () => {
                this.$rc.hideSpinner();
                this.$rc.alert('Error','Unable to find incident');
            },
        );
    },

    methods: {
        put: _.debounce(function(){
            this.doPut();
        }, 751),
        
        doPut()
        {
            this.$rc.rest(
                'PUT: /incidents',
                
                this.incident,
            
                (data) => {
                    // used to set data here... no more! (Caused editing issues!)
                },
            
                () => {
                    this.$rc.alert('Error','Unable to save changes');
                },
            );
        },

        onClickViewDetails()
        {
            this.$refs['detail-dialog'].showDialog(this.incident.incident_id);
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>